import { z } from "zod";
import { tenantContactSchema } from "./tenant-contact.js";
export const createCautionSchema = z.object({
    amount: z.number().int().positive(),
    note: z.string().max(2000).optional(),
    release_date: z.iso.datetime(),
    tenant: tenantContactSchema,
    booking_id: z.uuid().optional(),
});
